import { gql } from '@apollo/client'
import {
  companyManagerDashboardBoOfCompanyRowFragment,
  companyManagerDashboardBuOfCompanyRowFragment,
  companyManagerDashboardBumOfBusinessUnitRowFragment,
} from '../fragments/dashboardBusinessUnitsAndBranchOffices.fragments'

/** Company Manager Dashboard — business unit / branch office / BU manager counters. */
export const COMPANY_MANAGER_DASHBOARD_BUBOBUM_COUNTERS = gql`
  query CompanyManagerDashboardBubobumCounters($companyId: HashedId!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardBubobumCounters(companyId: $companyId, userDashboardRoles: $userDashboardRoles) {
      companyId
      businessUnit
      branchOffice
      buManagers
    }
  }
`

/** Company Manager Dashboard — business unit managers details grouped by business unit. */
export const COMPANY_MANAGER_DASHBOARD_BUM_OF_COMPANY = gql`
  query CompanyManagerDashboardBumOfCompany($companyId: HashedId!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardBumOfCompany(companyId: $companyId, userDashboardRoles: $userDashboardRoles) {
      companyId
      buManagers {
        ...CompanyManagerDashboardBumOfBusinessUnitRowFields
      }
    }
  }
  ${companyManagerDashboardBumOfBusinessUnitRowFragment}
`

/** Company Manager Dashboard — business units details. */
export const COMPANY_MANAGER_DASHBOARD_BU_OF_COMPANY = gql`
  query CompanyManagerDashboardBuOfCompany($companyId: HashedId!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardBuOfCompany(companyId: $companyId, userDashboardRoles: $userDashboardRoles) {
      companyId
      businessUnitsWithManagers {
        ...CompanyManagerDashboardBuOfCompanyRowFields
      }
    }
  }
  ${companyManagerDashboardBuOfCompanyRowFragment}
`

/** Company Manager Dashboard — branch offices details. */
export const COMPANY_MANAGER_DASHBOARD_BO_OF_COMPANY = gql`
  query CompanyManagerDashboardBoOfCompany($companyId: HashedId!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardBoOfCompany(companyId: $companyId, userDashboardRoles: $userDashboardRoles) {
      companyId
      branchOfficesWithEmployees {
        ...CompanyManagerDashboardBoOfCompanyRowFields
      }
    }
  }
  ${companyManagerDashboardBoOfCompanyRowFragment}
`
